export enum ConversationSentimentTypeEnum {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive',
}
